import { render, staticRenderFns } from "./AuthSignature.vue?vue&type=template&id=70f86f4f&"
import script from "./AuthSignature.vue?vue&type=script&lang=js&"
export * from "./AuthSignature.vue?vue&type=script&lang=js&"
import style0 from "./AuthSignature.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports